export const appStoreCopyEn = {
  title: 'Get the WandererTrip App',
  lead: 'Download the WandererTrip app for iPhone to plan and manage your trips on the go.',
  cta: 'Download on the App Store',
  redirecting: 'Redirecting to the App Store…',
  notOnIos: 'You can also visit the App Store directly to download the app.',
} as const;
